__turbopack_context__.v({
  "tempGroup": "Wkgs4a_tempGroup",
  "tierCool": "Wkgs4a_tierCool",
  "tierHot": "Wkgs4a_tierHot",
  "tierWarm": "Wkgs4a_tierWarm",
});
